import React from 'react';

const ExtendedView = () => {

    return (
        <div className="ExtendedView">
            <div className="modal fade" id="ExtViewStatusModal" tabIndex="-1" role="dialog" aria-labelledby="SharedOrgEmail" aria-hidden="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title " id="myModalLabel">Extended Status</div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="false">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <table className="custom-ag-theme spacer-margin8">
                                <thead>
                                    <tr>
                                        <th>Start Date/Time</th>
                                        <th>End Date/Time</th>
                                        <th>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2/21/2019 5:00:36 PM</td>
                                        <td>2/21/2020 5:05:36 PM</td>
                                        <td>Certificate has expired.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ExtendedView.defaultProps = {};

export default ExtendedView;
